import { ServiceData } from '@/types';

import articles from './ASTROLOGY_ARTICLES_FR.json';
import audios from './ASTROLOGY_AUDIOS_FR.json';

export const ASTROLOGY_DATA_FR: ServiceData = {
  articles,
  audios,
};
